// York glyph — a roll cage drawn at a given fill level, used by the
// york-fill prompt and both drop-off screens.
//
// Why a drawing rather than the fraction alone: the picker is looking
// at a real york while they answer. Matching a picture to the thing in
// front of them is faster than reading "3/4", and the five options
// become one glance down the column instead of five reads.
//
// The load is painted BEHIND the mesh so the wires read over it, which
// is what the picker actually sees. Mesh is currentColor at 0.35 so a
// single tone value colours frame, wheels and mesh coherently.
interface YorkGlyphProps {
    /** 0-4. Quarters full; 4 paints the full interior. */
    quarters: 0 | 1 | 2 | 3 | 4;
    /** Rendered width in px; height follows the 48:58 viewBox. */
    size?: number;
    /** Frame/wheel colour. The mesh derives from it. */
    tone?: string;
    className?: string;
}

// Interior runs y=6 (top) to y=44 (deck), so 38 units = a full york.
const INTERIOR_TOP = 6;
const INTERIOR_H = 38;

const YorkGlyph = ({ quarters, size = 44, tone = "#5b6470", className }: YorkGlyphProps) => {
    const fillH = (INTERIOR_H * quarters) / 4;
    const fillY = INTERIOR_TOP + (INTERIOR_H - fillH);
    // 4/4 fills to the frame, so it takes the frame's radius; a partial
    // load is a flat-topped block sitting on the deck.
    const full = quarters === 4;
    return (
        <svg
            width={size}
            height={Math.round((size * 58) / 48)}
            viewBox="0 0 48 58"
            fill="none"
            aria-hidden="true"
            className={className}
        >
            {fillH > 0 && (
                <rect
                    x="9" y={fillY} width="30" height={fillH}
                    rx={full ? 1.5 : 0}
                    fill={full ? "#ffb37a" : "#ffd0ab"}
                />
            )}
            <path
                d="M16 6v38M24 6v38M32 6v38M9 18h30M9 31h30"
                stroke={tone} strokeWidth="1.4" strokeOpacity="0.35"
            />
            <rect x="9" y="6" width="30" height="38" rx="1.5" stroke={tone} strokeWidth="2" />
            <path d="M6 46.5h36" stroke={tone} strokeWidth="2.6" strokeLinecap="round" />
            <path d="M13 48v2M35 48v2" stroke={tone} strokeWidth="1.8" strokeLinecap="round" />
            <circle cx="13" cy="52.8" r="2.9" stroke={tone} strokeWidth="1.8" />
            <circle cx="35" cy="52.8" r="2.9" stroke={tone} strokeWidth="1.8" />
        </svg>
    );
};

export default YorkGlyph;
